import { ChangeEvent, CSSProperties, type FocusEventHandler, forwardRef, KeyboardEventHandler } from 'react'

import { Textarea } from '@chakra-ui/react'
import { T } from '@chakra-ui/toast/dist/toast.types-f226a101'
import ResizeTextarea from 'react-textarea-autosize'

interface Props {
    size?: string
    bg?: string
    placeholder?: string
    borderColor?: string
    name?: string
    fontSize?: string
    borderRadius?: string
    value?: string
    onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void
    maxLength?: number
    minRows?: number
    maxRows?: number
    onBlur?: FocusEventHandler<T> | undefined
    autoFocus?: boolean
    onFocus?: FocusEventHandler<T> | undefined
    onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement> | undefined
    _placeholder?: CSSProperties
}

export const AutoResizeTextarea = forwardRef(({ minRows = 5, maxRows, autoFocus, onKeyDown, ...props }: Props, ref) => {
    return (
        <Textarea
            borderRadius={'4px'}
            px={4}
            minH={'unset'}
            overflow={'hidden'}
            w={'100%'}
            resize={'none'}
            // @ts-ignore
            ref={ref}
            minRows={minRows}
            maxRows={maxRows}
            as={ResizeTextarea}
            onKeyDown={onKeyDown}
            boxShadow={'none !important'}
            _focus={{ borderColor: '#245AF0' }}
            autoFocus={autoFocus}
            {...props}
        />
    )
})
